export default "__VITE_ASSET__ac5d81b2__"